const ZohoLink = ({ hidden, zohoId, t }) => {
  if (hidden) {
    return null
  }
  return (
    <div style={{ marginTop: '0.3rem' }}>
      <a
        style={{ color: 'rgb(1, 90, 163)' }}
        href={'https://crm.zoho.com/crm/org52021474/tab/Contacts/' + zohoId}
        target='_blank'
        rel='noopener noreferrer'
      >
        {t('subscriptionForm:zoho_module.link_zoho')}
      </a>
    </div>
  )
}

export default ZohoLink
